import { ko } from 'date-fns/locale/ko';
import { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    deleteFilterPAFAA010Conditions,
    fetchInitialConditions,
    saveFilterPAFAA010Conditions,
    saveMatchingConditions,
    updateFilterPAFAA010Conditions,
} from '../../../../redux/reducers/PAFAA010';
import { getPAFAA010search } from '../../../../services/Api';
import Checkbox from '../../../../shared/components/Checkbox';
import Dropdown from '../../../../shared/components/Dropdown';
import Radiobox from '../../../../shared/components/Radiobox';
import Tabs from '../../../../shared/components/Tabs';
import { getCheckBoxValues, getDropdownValue, getRadioBoxValue } from '../../../../utils';
registerLocale('ko', ko);

const PopupPAJAF010 = ({ onClose, decode, indexActive }) => {
    const [totalSelectedConditions, setTotalSelectedConditions] = useState(0);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [resumeLicenses, setResumeLicenses] = useState([]);
    const [resumeForms, setResumeForms] = useState([]);
    const [resumePositions, setResumePositions] = useState([]);
    const [resumePays, setResumePays] = useState([]);
    const [checkedLabels, setCheckedLabels] = useState([]);
    const [resumeCareers, setResumeCareers] = useState([]);

    const [resumeClass, setResumeClass] = useState([]);
    const [resumeProvinces, setResumeProvinces] = useState([]);
    const [resumeCommunes, setResumeCommunes] = useState({});
    const [selectedProvince, setSelectedProvince] = useState(null);

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [checkedValues, setCheckedValues] = useState({});
    const [checkedLikeRightValues, setCheckedLikeRightValues] = useState({});
    const [resumeRegionChecked, setResumeRegionChecked] = useState({
        RegionSi: [],
        RegionGu: [],
    });
    const [resumeRegion, setResumeRegion] = useState({});
    const [conditionSearch, setConditionSearch] = useState('Title');
    const [keywords, setKeywords] = useState([]);

    const savedConditions = useSelector(({ PAFAA010 }) => PAFAA010.savedPAFAA010Conditions || []);
    const dispatch = useDispatch();

    const [popupTabChange, setPopupTabChange] = useState(0);

    useEffect(() => {
        setTotalSelectedConditions(checkedLabels.length);
    }, [checkedLabels]);

    const handleTabChange = (index) => {
        setConditionSearch('CompanyName');
        setActiveTabIndex(index);
    };

    const handlePopupTabChange = (index) => {
        setPopupTabChange(index);
        const item = savedConditions[index];
        if (!item) {
            setCheckedLikeRightValues({});
            setCheckedValues({});
            setCheckedLabels([]);
            setStartDate('');
            setEndDate('');
            setKeywords([]);
            setResumeRegion({});
            return;
        }

        const {
            resumeRegionStore,
            checkedStoreValues,
            checkedLikeRightStoreValues,
            startStoreDate,
            endStoreDate,
            checkedStoreLabels,
        } = item;

        setCheckedValues(checkedStoreValues);
        setCheckedLikeRightValues(checkedLikeRightStoreValues);
        setStartDate(startStoreDate);
        setEndDate(endStoreDate);
        setResumeRegion(resumeRegionStore);
        setCheckedLabels(checkedStoreLabels);

        const keywordSet = new Set();
        if (checkedLikeRightStoreValues && !checkedLikeRightStoreValues['ResumeClass']) {
            Object.values(checkedLikeRightStoreValues).forEach((keywords) => {
                keywords.forEach((keyword) => keywordSet.add(keyword));
            });
        }
        setKeywords([...keywordSet]);
    };

    useEffect(() => {
        handlePopupTabChange(indexActive - 1 || 0);
        // eslint-disable-next-line
    }, []);

    // dropdown
    const handleOptionChange = (selectedValue, name) => {
        switch (name) {
            case 'conditionSearch':
                setConditionSearch(selectedValue);
                break;
            default:
                setCheckedValues((checkedValues) => getDropdownValue(checkedValues, name, selectedValue));
                break;
        }
    };

    // select box, radio box
    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;

        if (totalSelectedConditions >= 5 && checked) {
            alert('추천 인재 조건은 최대 5개까지 등록 가능합니다.');
            return;
        }

        setResumeRegion((checkedValues) => {
            let newCheckedValues = JSON.parse(JSON.stringify(checkedValues));

            const selectedRegionSi = Object.entries(resumeCommunes || {}).find(([key, communes]) =>
                communes.some((commune) => commune.code === value),
            );

            if (selectedRegionSi) {
                const [regionSiCode] = selectedRegionSi;
                const currentRegionGu = newCheckedValues[regionSiCode] || [];

                if (checked) {
                    if (currentRegionGu.length > 10) {
                        return checkedValues;
                    }

                    if (!newCheckedValues[regionSiCode]) {
                        newCheckedValues[regionSiCode] = [];
                    }

                    if (!newCheckedValues[regionSiCode].includes(value)) {
                        newCheckedValues[regionSiCode].push(value);
                    }
                } else {
                    // loại bỏ RegionGu khỏi RegionSi tương ứng
                    if (newCheckedValues[regionSiCode]) {
                        newCheckedValues[regionSiCode] = newCheckedValues[regionSiCode].filter(
                            (guCode) => guCode !== value,
                        );

                        // nếu không còn RegionGu nào trong RegionSi, xóa RegionSi
                        if (newCheckedValues[regionSiCode].length === 0) {
                            delete newCheckedValues[regionSiCode];
                        }
                    }
                }
            }
            return newCheckedValues;
        });

        setCheckedValues((checkedValues) => {
            let newCheckedValues = JSON.parse(JSON.stringify(checkedValues));

            if (type === 'checkbox' && name !== 'RegionGu') {
                // lấy value checkbox
                newCheckedValues = getCheckBoxValues(newCheckedValues, name, value, checked);
            } else if (type === 'radio') {
                // lấy value radio
                // trường hợp đặc biệt cho `resumeCareer`
                if (name === 'ResumeCareer' && value !== '009') {
                    // nếu không phải '경력': reset expMin và expMax

                    delete newCheckedValues.ExpMin;
                    delete newCheckedValues.ExpMax;
                }
                newCheckedValues = getRadioBoxValue(newCheckedValues, name, value, checked);
            }

            return newCheckedValues;
        });
    };

    const getOptions = (name) => {
        const options = {
            ResumeLicense: resumeLicenses.map((license) => ({
                id: 'resumeLicenses_' + license.code,
                label: license.codeName,
                value: license.code,
            })),

            ResumeForm: resumeForms.map((form) => ({
                id: 'resumeForms_' + form.code,
                label: form.codeName,
                value: form.code,
            })),

            ResumePosition: resumePositions.map((position) => ({
                id: 'resumePositions_' + position.code,
                label: position.codeName,
                value: position.code,
            })),

            ResumePay: resumePays.map((pay) => ({
                id: 'resumePays_' + pay.code,
                label: pay.codeName,
                value: pay.code,
            })),

            ResumeCareer: resumeCareers.map((career) => ({
                id: 'resumeCareers_' + career.code,
                label: career.codeName,
                value: career.code,
            })),

            ResumeCareerYear: [
                { value: '1', option: '1년' },
                { value: '2', option: '2년' },
                { value: '3', option: '3년' },
                { value: '4', option: '4년' },
                { value: '5', option: '5년' },
                { value: '6', option: '6년' },
                { value: '7', option: '7년' },
                { value: '8', option: '8년' },
                { value: '9', option: '9년' },
                { value: '10', option: '10년' },
                { value: '11', option: '11년' },
                { value: '12', option: '12년' },
                { value: '13', option: '13년' },
                { value: '14', option: '14년' },
                { value: '15', option: '15년' },
                { value: '16', option: '16년' },
                { value: '17', option: '17년' },
                { value: '18', option: '18년' },
                { value: '19', option: '19년' },
                { value: '20', option: '20년' },
                { value: '21', option: '21년' },
                { value: '22', option: '22년' },
                { value: '23', option: '23년' },
                { value: '24', option: '24년' },
                { value: '25', option: '25년' },
                { value: '26', option: '26년' },
                { value: '27', option: '27년' },
                { value: '28', option: '28년' },
                { value: '29', option: '29년' },
                { value: '30', option: '30년' },
            ],
        };
        return options[name];
    };

    // remove label
    const handleRemoveLabel = (label) => {
        // xử lý xóa StartDate và EndDate
        if (label.startsWith('채용기간:')) {
            setStartDate('');
            setEndDate('');
        }

        setCheckedValues((prevValues) => {
            const newValues = { ...prevValues };
            // duyệt qua các key trong checkedValues
            Object.entries(newValues || {}).forEach(([key, values]) => {
                const options = getOptions(key);

                // xử lý xóa ResumeCareer với giá trị '경력'
                if (key === 'ResumeCareer' && label.startsWith('경력:')) {
                    // xóa expMin và expMax khi label là dạng 경력: X ~ Y
                    delete newValues.ExpMin;
                    delete newValues.ExpMax;
                    delete newValues[key];
                    return;
                }

                // xử lý các giá trị khác
                if (!options) return;

                // tìm value tương ứng với label
                const matchedOption = options.find((option) => option.label === label);
                if (matchedOption) {
                    if (Array.isArray(values)) {
                        // nếu là mảng (checkbox), loại bỏ giá trị tương ứng
                        newValues[key] = values.filter((value) => value !== matchedOption.value);
                        if (newValues[key].length === 0) {
                            delete newValues[key];
                        }
                    } else if (values === matchedOption.value) {
                        // nếu là giá trị đơn (radio, select), đặt lại giá trị
                        delete newValues[key];
                    }
                }
            });
            return newValues;
        });

        setCheckedLikeRightValues((prevValues) => {
            const newValues = { ...prevValues };
            // xóa dữ liệu trong checkedLikeRightValues
            Object.entries(prevValues || {}).forEach(([key, values]) => {
                if (key === 'ResumeClass') {
                    values.forEach((code, index) => {
                        const resume = resumeClass.find((item) => item.code === code && item.codeName === label);

                        if (resume) {
                            newValues['ResumeClass'] = [...values.slice(0, index), ...values.slice(index + 1)];
                        }
                    });
                    if (newValues['ResumeClass'].length === 0) {
                        delete newValues['ResumeClass'];
                    }
                }
            });

            return newValues;
        });

        setResumeRegion((prevValues) => {
            const newValues = { ...prevValues };

            const [regionSiName, regionGuName] = label.split(' > ');

            const regionSi = resumeProvinces.find((province) => province.codeName === regionSiName);
            const regionSiCode = regionSi ? regionSi.code : null;

            let regionGuCode = null;
            if (regionSiCode) {
                const regionGu = resumeCommunes[regionSiCode]?.find((commune) => commune.codeName === regionGuName);
                if (regionGu) {
                    regionGuCode = regionGu.code;
                }
            }

            if (regionSiCode && regionGuCode) {
                if (newValues[regionSiCode]) {
                    newValues[regionSiCode] = newValues[regionSiCode].filter((code) => code !== regionGuCode);

                    if (newValues[regionSiCode].length === 0) {
                        delete newValues[regionSiCode];
                    }
                }
            }

            return newValues;
        });

        // xóa khỏi keywords và các trường 'Title', 'ResumeContent'
        const isKeywordLabel = label && keywords.includes(label); // kiểm tra có trong keywords list không

        if (isKeywordLabel) {
            // xóa keyword khỏi `keywords` state
            const keywordToRemove = label;

            setKeywords((prevKeywords) => {
                return prevKeywords.filter((keyword) => keyword !== keywordToRemove);
            });

            // xóa keyword khỏi `Title`, `ResumeContent` trong checkedLikeRightValues
            setCheckedLikeRightValues((prevValues) => {
                const newValues = { ...prevValues };

                ['Title', 'ResumeContent'].forEach((field) => {
                    if (newValues[field]) {
                        // loại bỏ keyword khỏi các trường này
                        newValues[field] = newValues[field].filter((value) => value !== keywordToRemove);

                        // nếu trống sau khi xóa keyword, xóa luôn key đó
                        if (newValues[field].length === 0) {
                            delete newValues[field];
                        }
                    }
                });

                return newValues;
            });
        }

        // xóa label khỏi danh sách `checkedLabels`
        setCheckedLabels((prevLabels) => prevLabels.filter((l) => l !== label));
    };
    // datetime input
    // const handleDateChange = (date, name) => {
    //     if (totalSelectedConditions >= 5) {
    //         alert('추천 인재 조건은 최대 5개까지 등록 가능합니다.');
    //         return;
    //     }
    //     if (name === 'startDate') {
    //         setStartDate(date);
    //     } else if (name === 'endDate') {
    //         setEndDate(date);
    //     }
    // };

    // tab 1
    useEffect(() => {
        if (resumeProvinces.length > 0) {
            setSelectedProvince(resumeProvinces[0].code);
        }
    }, [resumeProvinces]);
    const handleProvinceClick = (code) => {
        setSelectedProvince(code);
    };

    const communesToRender = resumeCommunes[selectedProvince] || [];

    // tab 2
    const handleCheckResumeClass = (code) => {
        const isAlreadySelected = (checkedLikeRightValues['ResumeClass'] || []).includes(code);

        if (totalSelectedConditions >= 5 && !isAlreadySelected) {
            alert('추천 인재 조건은 최대 5개까지 등록 가능합니다.');
            return;
        }

        setCheckedLikeRightValues((prevValues) => {
            const newValues = { ...prevValues };
            const resumeClass = newValues['ResumeClass'] || [];

            if (resumeClass.includes(code)) {
                newValues['ResumeClass'] = resumeClass.filter((item) => item !== code);
            } else {
                newValues['ResumeClass'] = [...resumeClass, code];
            }

            if (newValues['ResumeClass'].length === 0) {
                delete newValues['ResumeClass'];
            }

            return newValues;
        });
    };

    const handleInputKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (totalSelectedConditions >= 5) {
                alert('추천 인재 조건은 최대 5개까지 등록 가능합니다.');
                return;
            }

            const inputValue = e.target.value.trim();
            const inputName = e.target.name;

            if (inputValue) {
                if (keywords.length >= 3) {
                    return;
                }

                setCheckedLikeRightValues((prevValues) => {
                    const newValues = { ...prevValues };

                    if (inputName === 'searchAll') {
                        // thêm inputValue vào 'Title' và 'ResumeContent'
                        ['Title', 'ResumeContent'].forEach((key) => {
                            if (!newValues[key]) {
                                newValues[key] = [];
                            }

                            // thêm giá trị vào khóa tương ứng nếu nó chưa có ở đó
                            if (!newValues[key].includes(inputValue)) {
                                newValues[key].push(inputValue);
                            }
                        });
                    } else {
                        if (!newValues[conditionSearch]) {
                            newValues[conditionSearch] = [];
                        }
                        const updatedKeywords = [...newValues[conditionSearch], inputValue];
                        newValues[conditionSearch] = [...new Set(updatedKeywords)];
                    }

                    return newValues;
                });

                setKeywords((prevKeywords) => {
                    const updatedKeywords = [...prevKeywords, inputValue];
                    return [...new Set(updatedKeywords)];
                });

                e.target.value = '';
            }
        }
    };

    // get label
    const getCheckedLabels = () => {
        const labels = [];
        const startDateChecked =
            startDate !== undefined && moment(startDate).isValid() ? moment(startDate).format('yyyy-MM-DD') : '';
        const endDateChecked =
            endDate !== undefined && moment(endDate).isValid() ? moment(endDate).format('yyyy-MM-DD') : '';

        // lấy label từ checkedLikeRightValues
        Object.entries(checkedLikeRightValues || {}).forEach(([key, values]) => {
            if (key === 'ResumeClass') {
                const valueArray = Array.isArray(values) ? values : [values];
                valueArray.forEach((code) => {
                    const resume = resumeClass?.find((item) => item.code === code);

                    if (resume) {
                        labels.push(resume.codeName);
                    }
                });
            }
        });

        // lấy label từ checkedValues
        Object.entries(checkedValues || {}).forEach(([key, values]) => {
            const options = getOptions(key);
            const expMin = checkedValues.ExpMin !== undefined ? checkedValues.ExpMin + '년' : '';
            const expMax = checkedValues.ExpMax !== undefined ? checkedValues.ExpMax + '년' : '';

            if (!options) return;

            const valueArray = Array.isArray(values) ? values : [values];
            valueArray.forEach((value) => {
                const matchedOption = options?.find((option) => option.value === value);
                if (matchedOption) {
                    if (key === 'ResumeCareer' && value === '009') {
                        labels.push(`경력: ${expMin} ~ ${expMax}`);
                    } else {
                        labels.push(matchedOption.option || matchedOption.label); // Dùng option nếu có
                    }
                }
            });
        });

        // lấy label từ resumeRegion
        Object.entries(resumeRegion || {}).forEach(([regionSiCode, regionGuCodes]) => {
            const regionSi = resumeProvinces.find((province) => province.code === regionSiCode); // Lấy tên RegionSi từ resumeProvinces

            if (regionSi) {
                regionGuCodes.forEach((regionGuCode) => {
                    const commune = resumeCommunes[regionSiCode]?.find((commune) => commune.code === regionGuCode); // Tìm commune
                    if (commune) {
                        labels.push(`${regionSi.codeName} > ${commune.codeName}`);
                    }
                });
            }
        });

        if (keywords && keywords.length > 0) {
            keywords.forEach((keyword) => {
                labels.push(keyword);
            });
        }

        if (startDate || endDate) {
            labels.push(`채용기간: ${startDateChecked} ~ ${endDateChecked}`);
        }

        return labels;
    };

    useEffect(() => {
        const regionSi = Object.keys(resumeRegion);
        const regionGu = Object.values(resumeRegion).flat();

        setResumeRegionChecked({
            RegionSi: regionSi,
            RegionGu: regionGu,
        });
    }, [resumeRegion]);

    useEffect(() => {
        getPAFAA010search()
            .then(({ data }) => {
                setResumeProvinces(data.resumeProvinces);
                setResumeCommunes(data.resumeCommunes);
                setResumeClass(data.resumeClass);
                setResumeLicenses(data.resumeLicense);
                setResumeForms(data.resumeForm);
                setResumePositions(data.resumePosition);
                setResumePays(data.resumePay);
                setResumeCareers(data.resumeCareer);
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        setCheckedLabels(getCheckedLabels);
        // eslint-disable-next-line
    }, [checkedValues, checkedLikeRightValues, resumeClass, startDate, endDate]);

    useEffect(() => {
        dispatch(fetchInitialConditions());
    }, [dispatch]);

    const handleUpdateCondition = (index) => {
        const savedDate = moment().format('YYYY/MM/DD');
        const startDateFormat = startDate ? moment(startDate).format('YYYY/MM/DD') : '';
        const endDateFormat = endDate ? moment(endDate).format('YYYY/MM/DD') : '';

        const totalConditions = savedConditions.length;

        if (index > totalConditions) {
            window.alert(`추천 인재 조건을 탭 순서로 저장하셔야 됩니다.`);
            return;
        }
        if (window.confirm('추천 인재 조건을 설정하시겠습니까?')) {
            if (
                Object.keys(checkedLikeRightValues).length === 0 &&
                Object.keys(checkedValues).length === 0 &&
                Object.keys(resumeRegion).length === 0 &&
                startDateFormat === '' &&
                endDateFormat === '' &&
                checkedLabels.length === 0
            ) {
                dispatch(deleteFilterPAFAA010Conditions(index));
                dispatch(saveMatchingConditions(decode.seq));
                return;
            }

            if (totalConditions === 0 || index === totalConditions) {
                dispatch(
                    saveFilterPAFAA010Conditions({
                        checkedLikeRightValues,
                        resumeRegion,
                        checkedValues,
                        startDate: startDate ? moment(startDate).format('YYYY/MM/DD') : '',
                        endDate: endDate ? moment(endDate).format('YYYY/MM/DD') : '',
                        savedDate,
                        checkedLabels,
                    }),
                );
                dispatch(saveMatchingConditions(decode.seq));
            }

            if (index < totalConditions) {
                dispatch(
                    updateFilterPAFAA010Conditions({
                        index,
                        updatedCondition: {
                            checkedStoreValues: checkedValues,
                            checkedLikeRightStoreValues: checkedLikeRightValues,
                            startStoreDate: startDateFormat,
                            endStoreDate: endDateFormat,
                            savedStoreDate: savedDate,
                            checkedStoreLabels: checkedLabels,
                            resumeRegionStore: resumeRegion,
                        },
                    }),
                );
                dispatch(saveMatchingConditions(decode.seq));
            }
            alert('추천 인재 조건이 설정되었습니다.');
            onClose();
        } else {
            return;
        }
    };

    return (
        <div className="mtch-pop active">
            <div className="mtch-pop__inner">
                <h2 className="mtch-pop__tit">추천 인재 조건</h2>
                <button type="button" id="mtchPopClose" className="rsm-prv__close" onClick={onClose} />
                <div className="mtch-pop__flex">
                    <ul className="mtch-pop__tab">
                        {Array.from({ length: 3 }).map((_, index) => (
                            <li key={'popupTab_' + index}>
                                <button
                                    type="button"
                                    className={`mtch-pop__tab-btn ${popupTabChange === index ? 'active' : ''}`}
                                    onClick={() => handlePopupTabChange(index)}
                                >
                                    스마트매칭 {index + 1}
                                </button>
                            </li>
                        ))}
                    </ul>
                    <div id="tabs-form" className="mtch-pop__section">
                        <div className="mtch-pop__block active">
                            <h3 className="mtch-pop__sbj">매칭조건 {popupTabChange + 1}</h3>
                            <div>
                                <div className="container">
                                    <Tabs
                                        tabs={[
                                            { label: '지역 선택', icon: 'icon-location', isActive: true },
                                            { label: '업무 선택', icon: 'icon-bag', isActive: false },
                                            {
                                                label: (
                                                    <input
                                                        type="text"
                                                        placeholder="검색어 입력"
                                                        name="searchAll"
                                                        onKeyPress={handleInputKeyPress}
                                                    />
                                                ),
                                                icon: 'icon-search',
                                                isActive: false,
                                            },
                                            { label: '상세조건', icon: 'icon-plus', isActive: false },
                                        ]}
                                        blackTab
                                        onTabChange={handleTabChange}
                                    />
                                    <div className="mtch-pop__select">
                                        {activeTabIndex === 0 && (
                                            <div className="mtch-pop__show active">
                                                <div className="tab tabs-select">
                                                    <div className="tabs-flex">
                                                        <div className="tabs-left">
                                                            <ul>
                                                                {resumeProvinces.map((province, index) => (
                                                                    <li
                                                                        className={
                                                                            province.code === selectedProvince
                                                                                ? 'active'
                                                                                : ''
                                                                        }
                                                                        key={index}
                                                                        onClick={() =>
                                                                            handleProvinceClick(province.code)
                                                                        }
                                                                    >
                                                                        <span className="city-name">
                                                                            {province.codeName}
                                                                        </span>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                        <div className="tabs-right">
                                                            <form>
                                                                {communesToRender.length > 0 && (
                                                                    <>
                                                                        <p className="notification">
                                                                            지역은 최대 <span>5</span>개까지 선택
                                                                            가능합니다.
                                                                        </p>
                                                                        <ul>
                                                                            <Checkbox
                                                                                name="RegionGu"
                                                                                options={communesToRender.map(
                                                                                    (commune) => ({
                                                                                        id: 'regionGu_' + commune.code,
                                                                                        value: commune.code,
                                                                                        label: `${commune.codeName}`,
                                                                                    }),
                                                                                )}
                                                                                onChange={handleInputChange}
                                                                                checked={resumeRegionChecked}
                                                                            />
                                                                        </ul>
                                                                    </>
                                                                )}
                                                            </form>
                                                        </div>
                                                    </div>
                                                    <div className="bsns-srch">
                                                        <Dropdown
                                                            placeholder=""
                                                            options={[
                                                                { value: 'Title', option: '제목' },
                                                                { value: 'ResumeContent', option: '내용' },
                                                            ]}
                                                            value={conditionSearch}
                                                            name="conditionSearch"
                                                            onChange={handleOptionChange}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder="검색어 입력하세요"
                                                            onKeyPress={handleInputKeyPress}
                                                        />
                                                    </div>{' '}
                                                </div>
                                            </div>
                                        )}
                                        {activeTabIndex === 1 && (
                                            <div className="mtch-pop__show active">
                                                <div
                                                    className={`tab tabs-select tabs-select-bag tab-${resumeClass && resumeClass.length % 4 === 0 ? 4 : 5
                                                        }-item`}
                                                >
                                                    <ul>
                                                        {resumeClass.map((resume) => (
                                                            <li
                                                                key={resume.code}
                                                                onClick={() => handleCheckResumeClass(resume.code)}
                                                                className={
                                                                    checkedLikeRightValues?.['ResumeClass'] &&
                                                                        checkedLikeRightValues['ResumeClass']?.includes(
                                                                            resume.code,
                                                                        )
                                                                        ? 'active'
                                                                        : ''
                                                                }
                                                            >
                                                                {resume.codeName}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                    <div className="bsns-srch">
                                                        <Dropdown
                                                            placeholder=""
                                                            options={[
                                                                { value: 'CompanyName', option: '치과명' },
                                                                { value: 'Title', option: '제목' },
                                                                { value: 'FTS_Contents', option: '내용' },
                                                            ]}
                                                            value={conditionSearch}
                                                            name="conditionSearch"
                                                            onChange={handleOptionChange}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder="검색어 입력하세요"
                                                            onKeyPress={handleInputKeyPress}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {activeTabIndex === 3 && (
                                            <div className="mtch-pop__show active">
                                                <div className="tab tabs-content tabs-select-plus">
                                                    <div className="wrap-select-plus-child">
                                                        <div className="title-detailed">자격증</div>
                                                        <ul className="tab-check-box">
                                                            <Checkbox
                                                                name="ResumeLicense"
                                                                options={getOptions('ResumeLicense')}
                                                                onChange={handleInputChange}
                                                                checked={checkedValues}
                                                            />
                                                        </ul>
                                                    </div>
                                                    <div className="wrap-select-plus-child">
                                                        <div className="title-detailed">근무형태</div>
                                                        <ul className="tab-check-box">
                                                            <Checkbox
                                                                name="ResumeForm"
                                                                options={getOptions('ResumeForm')}
                                                                onChange={handleInputChange}
                                                                checked={checkedValues}
                                                            />
                                                        </ul>
                                                    </div>
                                                    <div className="wrap-select-plus-child">
                                                        <div className="title-detailed">직급</div>
                                                        <ul className="tab-check-box">
                                                            <Checkbox
                                                                name="ResumePay"
                                                                options={getOptions('ResumePay')}
                                                                onChange={handleInputChange}
                                                                checked={checkedValues}
                                                            />
                                                        </ul>
                                                    </div>
                                                    <div className="wrap-select-plus-child">
                                                        <div
                                                            className="title-detailed"
                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                        >
                                                            경력
                                                        </div>
                                                        <div className="group">
                                                            <Radiobox
                                                                name="ResumeCareer"
                                                                options={getOptions('ResumeCareer')}
                                                                onChange={handleInputChange}
                                                                checked={checkedValues}
                                                                className="radiobox-style"
                                                            />
                                                            {Array.isArray(checkedValues.ResumeCareer) &&
                                                                checkedValues.ResumeCareer.includes('009') && (
                                                                    <>
                                                                        (
                                                                        <Dropdown
                                                                            placeholder="경력기간선택"
                                                                            options={getOptions(
                                                                                'ResumeCareerYear',
                                                                            ).filter(
                                                                                (option) =>
                                                                                    parseInt(option.value, 10) <
                                                                                    parseInt(
                                                                                        checkedValues.expMax || '999',
                                                                                        10,
                                                                                    ),
                                                                            )}
                                                                            name={'ExpMin'}
                                                                            onChange={handleOptionChange}
                                                                        />
                                                                        ~
                                                                        <Dropdown
                                                                            placeholder="경력기간선택"
                                                                            options={getOptions(
                                                                                'ResumeCareerYear',
                                                                            ).filter(
                                                                                (option) =>
                                                                                    parseInt(option.value, 10) >
                                                                                    parseInt(
                                                                                        checkedValues.expMin || '0',
                                                                                        10,
                                                                                    ),
                                                                            )}
                                                                            name={'ExpMax'}
                                                                            onChange={handleOptionChange}
                                                                        />
                                                                        )
                                                                    </>
                                                                )}
                                                        </div>
                                                    </div>

                                                    {/* <div className="wrap-select-plus-child">
                                                        <div className="title-detailed">채용기간</div>
                                                        <div className="group-datepicker">
                                                            <div className="datepicker-child">
                                                                <DatePicker
                                                                    onChange={(date) =>
                                                                        handleDateChange(date, 'startDate')
                                                                    }
                                                                    locale={'ko'}
                                                                    placeholderText={'YYYY/MM/DD'}
                                                                    dateFormat={'yyyy/MM/dd'}
                                                                    selected={startDate}
                                                                    maxDate={endDate || null}
                                                                />
                                                                <i className="icon icon-date" id="start-date-icon" />
                                                            </div>
                                                            <span>~</span>
                                                            <div className="datepicker-child">
                                                                <DatePicker
                                                                    onChange={(date) =>
                                                                        handleDateChange(date, 'endDate')
                                                                    }
                                                                    locale={'ko'}
                                                                    placeholderText={'YYYY/MM/DD'}
                                                                    dateFormat={'yyyy/MM/dd'}
                                                                    selected={endDate}
                                                                    minDate={startDate || null}
                                                                />
                                                                <i className="icon icon-date" id="end-date-icon" />
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="tab-select-results">
                                        <ul className="results-area">
                                            {Array.isArray(checkedLabels) &&
                                                checkedLabels.length > 0 &&
                                                checkedLabels.map((label, index) => (
                                                    <li key={index}>
                                                        <div className="item-search">{label}</div>
                                                        <span
                                                            className="item-remove icon icon-x"
                                                            onClick={() => handleRemoveLabel(label)}
                                                        ></span>
                                                    </li>
                                                ))}
                                        </ul>
                                        <div className="wrap-option-search-block">
                                            <button onClick={() => handleUpdateCondition(popupTabChange)}>
                                                선택한 조건으로<span>검색하기</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopupPAJAF010;
